module.exports = __webpack_public_path__ + "img/icon_logo_blue.e44f16b7.png";